import { DateTime } from "./imports";
import { currentState } from "./config";
import { updateClock, initializeClockForObservatory } from "./panels/clock";
import { updateAllSkyImage } from "./panels/allsky_images";
import {
  updateAstronomicalOverview,
  updateWeatherOverview,
  updateVisibilityOverview,
  updatePowerOverview,
} from "./panels/status_overview";
import { updateObservatoryTitle } from "./observatories/init_observatories";
import {
  resetOverviewText,
  resetAllSkyImage,
  updateRefreshButtonState,
} from "./panels/loading";
import { allowRefresh } from "./utils";
import { initializeGraphs, refreshGraphs } from "./graphs/initialize_graphs";

/**
 * Function to be called from main, should only be run once
 */
export async function initializePage() {
  setInterval(updateClock, 250);
  await initializeGraphs(); // needs to be before switchObservatory, since that refreshes graphs
  await switchObservatory();
  addRefreshButtonListener();
  setInterval(updateRefreshButtonState, 250);
  startAutoRefresh();
}

/**
 * Function to refresh needed elements when observatory is switched
 * Also called as part of initialization
 */
export async function switchObservatory() {
  // clear previous information
  resetOverviewText();
  clearRefreshTime();
  resetAllSkyImage();

  // set up for the new observatory
  initializeClockForObservatory();
  updateObservatoryTitle();
  await refreshObservatoryData();
}

/**
 * Refreshes elements for a single observatory
 * Only runs if it hasn't run recently
 */
export async function refreshObservatoryData() {
  if (!allowRefresh()) {
    return;
  }
  await updateAllSkyImage();
  await updateAstronomicalOverview();
  await updateWeatherOverview();
  await updateVisibilityOverview();
  await updatePowerOverview();
  refreshGraphs();

  setRefreshTime();
}

// Helpers for the three main functions
function addRefreshButtonListener() {
  document
    .getElementById("refresh-data-button")
    .addEventListener("click", refreshObservatoryData);
}
// Functions for managing the refresh time
const setRefreshTime = () => (currentState.lastRefresh = DateTime.now());
const clearRefreshTime = () => (currentState.lastRefresh = null);

function startAutoRefresh() {
  currentState.refreshIntervalID ??= setInterval(
    refreshObservatoryData,
    300000
  );
}
